export default __webpack_public_path__ + "assets/3066bc0edfba70d46e965f3ed988fdcc.woff";